<template>
  <div class="welcome-container">
    <img src="@/assets/logo.png" alt="Promba Logo" class="logo" />

    <h1 dir="rtl">العب أبو وديع ... 🎉</h1>
    <p class="subtitle">{{ typedText }}</p>


    <div class="cards-display">
      <div class="card" v-for="(player, index) in players" :key="index">
        <img :src="player.img" :alt="player.card" />
        <p>{{ player.card }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

// Players data for the card images
const players = [
  { card: 'King of Spades', img: require('@/assets/king.png') },
  { card: 'Queen of Hearts', img: require('@/assets/queen.png') },
  { card: 'Ace of Clubs', img: require('@/assets/ace.png') },
  { card: 'Jack of Diamonds', img: require('@/assets/jack.png') }
]

// Typing effect data
const fullText = `Welcome to Promba — where strategy meets fun! Choose your cards, challenge your friends, and play your way to victory.`
const typedText = ref('')

// Typing function
const startTyping = () => {
  typedText.value = ''
  let currentIndex = 0
  const typeInterval = setInterval(() => {
    if (currentIndex < fullText.length) {
      typedText.value += fullText[currentIndex]
      currentIndex++
    } else {
      clearInterval(typeInterval)
    }
  }, 50)
}

// Start typing on mount and repeat every 20 seconds
onMounted(() => {
  startTyping()
  setInterval(startTyping, 20000)
})
</script>



<style scoped>
.welcome-container {
  background: #fffefc;
  padding: 2rem;
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.logo {
  height: 80px;
  margin-bottom: 20px;
}

h1 {
  color: #333;
  font-size: 2.8rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.cards-display {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-8px);
}

.card img {
  width: 120px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.card p {
  margin-top: 0.6rem;
  color: #2c3e50;
  font-weight: 600;
}
</style>
